"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    initMapManager: ()=>initMapManager,
    mapManager: ()=>mapManager
});
const js_api_loader_namespaceObject = require("@googlemaps/js-api-loader");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const googleMapConst_js_namespaceObject = require("../../constants/googleMapConst.js");
const external_createMapAdvancedMarkerElement_js_namespaceObject = require("./createMapAdvancedMarkerElement.js");
const initMapManager = ()=>{
    let map = null;
    let loader = null;
    let mapMarkerLib = null;
    let mapCoreLib = null;
    let seti;
    const callbacks = [];
    return {
        initloader: (options)=>{
            if ('undefined' != typeof window && 'function' == typeof window.google?.maps?.importLibrary) loader = window.google.maps;
            if (!loader) loader = new js_api_loader_namespaceObject.Loader({
                apiKey: googleMapConst_js_namespaceObject.GOOGLE_MAP_API_KEY,
                version: 'weekly'
            });
            if (options?.setiValues) seti = {
                ...options.setiValues
            };
            return loader;
        },
        setMap: async ()=>{
            const { Map } = await loader.importLibrary('maps');
            map = new Map(document.getElementById('PENNY-SEARCH-GOOGLE-MAP'), {
                zoomControl: true,
                fullscreenControl: false,
                cameraControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                center: {
                    lat: 40.7128,
                    lng: -74.006
                },
                zoom: 8,
                mapId: googleMapConst_js_namespaceObject.PRICELINE_MAP_ID
            });
            mapMarkerLib = await loader.importLibrary('marker');
            mapCoreLib = await loader.importLibrary('core');
        },
        addCallback: function(cb) {
            callbacks.push(cb);
            if (map) this.fireCallbacks();
        },
        fireCallbacks: function() {
            while(callbacks.length > 0){
                const cb = callbacks.shift();
                const options = {
                    map,
                    loader
                };
                cb(options);
            }
        },
        fitBoundsOnCurrentMap: async function(listOfPins) {
            if (!map || !loader || !Array.isArray(listOfPins) || 0 === listOfPins.length) return;
            try {
                const { LatLngBounds } = mapCoreLib;
                const bounds = new LatLngBounds();
                listOfPins.forEach((pin)=>{
                    const latLng = {
                        lat: Number(pin.lat),
                        lng: Number(pin.lng)
                    };
                    if (!Number.isNaN(latLng.lat) && !Number.isNaN(latLng.lng)) bounds.extend(latLng);
                });
                const manager = this;
                if (1 === listOfPins.length) {
                    setTimeout(()=>{
                        manager.createAdvancedMarker(listOfPins[0]);
                    }, 200);
                    map.setCenter(bounds.getCenter());
                    map.setZoom(17);
                } else {
                    setTimeout(()=>{
                        listOfPins.forEach((pin)=>{
                            manager.createAdvancedMarker(pin);
                        });
                    }, 200);
                    map.fitBounds(bounds);
                }
            } catch (e) {
                analytics_js_default().logError({
                    loggedFrom: 'initMapManager:fitBoundsOnCurrentMap',
                    message: 'Failed to call fitBounds on map',
                    error: e.message
                });
            }
        },
        createAdvancedMarker: function(options) {
            const { AdvancedMarkerElement } = mapMarkerLib;
            (0, external_createMapAdvancedMarkerElement_js_namespaceObject.createMapAdvancedMarkerElement)({
                gMap: map,
                AdvancedMarkerElement,
                pinDetails: options,
                seti
            });
        }
    };
};
const mapManager = initMapManager();
exports.initMapManager = __webpack_exports__.initMapManager;
exports.mapManager = __webpack_exports__.mapManager;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "initMapManager",
    "mapManager"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
